import { render, staticRenderFns } from "./InvoicesPackPanel.vue?vue&type=template&id=3b0a5626&scoped=true"
import script from "./InvoicesPackPanel.vue?vue&type=script&lang=js"
export * from "./InvoicesPackPanel.vue?vue&type=script&lang=js"
import style0 from "./InvoicesPackPanel.vue?vue&type=style&index=0&id=3b0a5626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a5626",
  null
  
)

export default component.exports